<template>
  <ul class="sidebar-menu">
    <li class="header">TOOLS</li>
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Dashboard</span>
      </a>
    </router-link>

    <!-- <router-link tag="li" class="pageLink" to="/allstudents">
      <a>
        <i class="fa fa-id-badge"></i>
        <span class="page">All Students</span>
      </a>
    </router-link> -->
    <router-link tag="li" class="pageLink" to="/makers">
      <a>
        <i class="fa fa-id-badge"></i>
        <span class="page">Makers</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/series">
      <a>
        <i class="fa fa-id-badge"></i>
        <span class="page">Model Series</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/types">
      <a>
        <i class="fa fa-id-badge"></i>
        <span class="page">Types</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/cars">
      <a>
        <i class="fa fa-id-badge"></i>
        <span class="page">Cars</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/variants">
      <a>
        <i class="fa fa-id-badge"></i>
        <span class="page">Variants</span>
      </a>
    </router-link>
    <!-- <router-link tag="li" class="pageLink" to="/allfiles">
      <a>
        <i class="fa fa-id-badge"></i>
        <span class="page">All Files</span>
      </a>
    </router-link> -->
    <!-- <router-link tag="li" class="pageLink" to="/allteachers">
      <a>
        <i class="fa fa-user-circle"></i>
        <span class="page">All Teachers</span>
      </a>
    </router-link> -->

    <!-- <router-link tag="li" class="pageLink" to="/curriculum">
      <a>
        <i class="fa fa-book"></i>
        <span class="page">Curriculum</span>
      </a>
    </router-link> -->
  </ul>
</template>
<script>
export default {
  name: "SidebarMenu",
  mounted() {
    this.CheckLogin();
  },
  methods: {
    CheckLogin() {
      if (localStorage.getItem("user")) {
        console.log(localStorage.getItem("user"));
      } else {
        console.log("admin object not set");
        this.$router.push("/login");
      }
    },
  },
};
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?8e1c21a6